import React, { useEffect, useState } from 'react';
import { Percent } from 'lucide-react';
import { fatturazioneAPI } from '../../services/fatturazioneApi';
import '../../styles/ScontoTotale.css';

/**
 * ScontoTotale — la casella «Sconto sul totale» di un documento in bozza.
 *
 * UNA COPIA SOLA (Alex, 28 settembre 2026): la usano la linguetta «Cassa»
 * del paziente e il «Nuovo documento» di Fatturazione, che fino a quel
 * giorno non l'aveva. La casella manda solo l'importo
 * (PATCH /fatturazione/:id/sconto): la ripartizione sulle aliquote e sulle
 * righe la fa il database, una volta sola (migration 262), e i totali che
 * si vedono sono quelli che il server restituisce. Qui non si calcola
 * niente.
 *
 * @param {number}   fatturaId
 * @param {*}        sconto        lo sconto_finale del documento, com'e' adesso
 * @param {function} onAggiornato  dopo il salvataggio: rileggere il documento
 * @param {function} onErrore      il messaggio del server, se il salvataggio non riesce
 */
const ScontoTotale = ({ fatturaId, sconto, onAggiornato, onErrore }) => {
    const [testo, setTesto] = useState('');
    useEffect(() => {
        const v = parseFloat(sconto || 0);
        setTesto(v > 0 ? String(v) : '');
    }, [fatturaId, sconto]);

    const salva = async () => {
        const v = parseFloat(String(testo).replace(',', '.')) || 0;
        if (Math.round(v * 100) === Math.round(parseFloat(sconto || 0) * 100)) return;
        try {
            await fatturazioneAPI.impostaSconto(fatturaId, v);
            if (onAggiornato) await onAggiornato();
        } catch (e) {
            if (onErrore) onErrore(e?.response?.data?.message || 'Errore nell\'impostazione dello sconto');
        }
    };

    return (
        <div className="sconto-totale">
            <Percent size={15} aria-hidden="true" />
            <label htmlFor={`sconto-totale-${fatturaId}`}>Sconto sul totale</label>
            <input id={`sconto-totale-${fatturaId}`} className="sconto-totale-campo" type="number"
                step="0.01" min="0" placeholder="0,00"
                value={testo}
                onChange={(e) => setTesto(e.target.value)}
                onBlur={salva}
                onKeyDown={(e) => { if (e.key === 'Enter') salva(); }} />
            <span className="sconto-totale-nota">
                si ripartisce sulle basi imponibili, così l&apos;IVA resta coerente
            </span>
        </div>
    );
};

export default ScontoTotale;
